import { Component, Input, OnInit } from '@angular/core';
import { AppComponent } from './../app.component';
 
import {  TraslateService} from '../../app/traslate.service';
import { from, interval, Observable } from 'rxjs';
import { map, takeWhile } from 'rxjs/operators';
import MarkerClusterer from '@googlemaps/markerclustererplus';
import { ClusterOptions, ClusterStyle } from '@agm/js-marker-clusterer/services/google-clusterer-types';
import { TravelMarker, TravelMarkerOptions, TravelData, TravelEvents, EventType } from 'travel-marker';
import { AgmMarkerCluster } from '@agm/js-marker-clusterer/directives/marker-cluster';

 

// just an interface for type safety.
interface marker {
	lat: number;
	lng: number;
	label?: string;
	draggable: boolean;
}
 
@Component({
  selector: 'app-slider',
  templateUrl: './slider.component.html',
  styleUrls: ['./slider.component.css']
})
export class SliderComponent implements OnInit {



  public lat11 = 24.799448;
public lng11 = 120.979021;

public origin: any;
public destination: any;

 
getDirection() {
  this.origin = { lat: 24.799448, lng: 120.979021 };
  this.destination = { lat: 24.799524, lng: 120.975017 };

  // Location within a string
  // this.origin = 'Taipei Main Station';
  // this.destination = 'Taiwan Presidential Office';
}


  locationData = [[51.51324,-0.09909000000000001],[51.5133,-0.09908],[51.5133,-0.09908],[51.513290000000005,-0.09895000000000001],[51.514880000000005,-0.08285000000000001],[51.5148,-0.08264],[51.51478,-0.08261],[51.514770000000006,-0.08257],[51.514770000000006,-0.08256000000000001],[51.51476,-0.08252000000000001],[51.51475000000001,-0.08248000000000001],[51.51474,-0.08237000000000001],[51.514720000000004,-0.08226000000000001],[51.51469,-0.08214],[51.51467,-0.08207],[51.514660000000006,-0.08204],[51.51464000000001,-0.08201000000000001],[51.51462,-0.08198000000000001],[51.514590000000005,-0.08195000000000001],[51.51455000000001,-0.08191000000000001],[51.51451,-0.08188000000000001],[51.51451,-0.08188000000000001],[51.514520000000005,-0.08135],[51.514520000000005,-0.08132],[51.51451,-0.08129],[51.514500000000005,-0.08125],[51.51449,-0.08118],[51.514430000000004,-0.08099],[51.514430000000004,-0.08099],[51.51455000000001,-0.0809],[51.5146,-0.08088000000000001],[51.51464000000001,-0.08085],[51.51475000000001,-0.08080000000000001],[51.51478,-0.08078] ]

// google maps zoom level
zoom1: number = 20;
iconStart:any={  url: 'https://play-lh.googleusercontent.com/m5NS39Zkz-_DiRFWFfEpKxeSQlFOZMD5wJFfqf9Y3r9toqqi3yqOy1c2rpoY162pHg76',  scaledSize: {  width: 50,  height: 50  }}
iconEnd:any={  url: 'https://cdn0.iconfinder.com/data/icons/online-shopping-57/106/map_route_end-512.png',  scaledSize: {  width: 60,  height: 60  }}

// initial center position for the map
lat1: number = 51.512802;
lng1: number = -0.091324;
private _clustererInstance: Promise<MarkerClusterer>;
map: any;
line: any;
directionsService: any;
marker: TravelMarker = null;
title:any;
// speedMultiplier to control animation speed
speedMultiplier = 1;
  route: any;
  routeJSON: string;

onMapReady(map: any) {
  //console.log(map);
  this.map = map;
  // this.calcRoute();
  this.mockDirections();
  // this.initEvents();
 
}


onMouseOver(infoWindow, $event: google.maps.MouseEvent) {
  infoWindow.open();
  //console.log('hello')
}
onMouseOut(infoWindow, $event: MouseEvent) {
  infoWindow.close();
  //console.log('I m out')
}


 // mock directions api
 mockDirections() {
  const locationArray = this.locationData.map(l => new google.maps.LatLng(l[0], l[1]));
  this.line = new google.maps.Polyline({
    strokeOpacity: 0.5,
    path: [],
    map: this.map
  });

  locationArray.forEach(l => {this.line.getPath().push(l);
    console.log(JSON.stringify(this.line.getPath()))});
  console.log( this.marker)
  const start = new google.maps.LatLng(51.513237, -0.099102);
  const end = new google.maps.LatLng(51.514786, -0.080799);


  const startMarker = new google.maps.Marker({position: start, map: this.map, label: 'A'});
  const endMarker = new google.maps.Marker({position: end, map: this.map, label: 'B'});
  
  this.initRoute();
}

// initialize travel marker
initRoute() {
  this.route = this.line.getPath().getArray();
//console.log(typeof(this.route))
this.routeJSON = JSON.stringify(this.route)
this.locationData.forEach(element => {
 ////console.log(element[0])
 new google.maps.Marker({position: new google.maps.LatLng(element[0], element[1]), map: this.map, label: 'B'});
});
  // options
  const options: TravelMarkerOptions = {
    map: this.map,  // map object
    speed: 50,  // default 10 , animation speed
    interval: 10, // default 10, marker refresh time
    speedMultiplier: this.speedMultiplier,
    cameraOnMarker: true, 
    markerType: 'overlay',
    markerOptions: { 
      title: 'Travel Marker',
      animation: google.maps.Animation.DROP,
      icon: {
        url: 'https://i.imgur.com/eTYW75M.png',
        // This marker is 20 pixels wide by 32 pixels high.
        animation: google.maps.Animation.DROP,
        // size: new google.maps.Size(256, 256),
        scaledSize: new google.maps.Size(128, 128),
        // The origin for this image is (0, 0).
        origin: new google.maps.Point(0, 0),
        // The anchor for this image is the base of the flagpole at (0, 32).
        anchor: new google.maps.Point(53, 110)
      }
    },
  };

  // define marker
  this.marker = new TravelMarker(options);
  
  // add locations from direction service 
  this.marker.addLocation(this.route);
    
  setTimeout(() => this.play(), 2000);
}

// play animation
play() {
  this.marker.play();
}

// pause animation
pause() {
  this.marker.pause();
}

// reset animation
reset() {
  this.marker.reset();
}

// jump to next location
next() {
  this.marker.next();
}

// jump to previous location
prev() {
  this.marker.prev();
}

// fast forward
fast() {
  this.speedMultiplier*=2;
  this.marker.setSpeedMultiplier(this.speedMultiplier);
}

// slow motion
slow() {
  this.speedMultiplier/=2;
  this.marker.setSpeedMultiplier(this.speedMultiplier)
}

initEvents() {
  this.marker.event.onEvent((event: EventType, data: TravelData) => {
    //console.log(event, data);
  });
}























  
  clusterStyles: ClusterStyle[];
  clusterOptions: ClusterOptions;
  icon:any = {
    url: 'http://earth.google.com/images/kml-icons/track-directional/track-4.png',
    scaledSize: {
      width: 30,
      height: 30
    }}
  constructor() { }

 
  ngOnInit(): void {
    this.getDirection();
    this.drawPath()
    this.clusterStyles = [
      {
          textColor: "#FFFFFF",
          url: "https://raw.githubusercontent.com/mikesaidani/marker-clusterer-plus/master/images/m1.png",
          height: 50,
          width: 50
      },
      {
          textColor: "#FFFFFF",
          url: "https://raw.githubusercontent.com/mikesaidani/marker-clusterer-plus/master/images/m2.png",
          height: 50,
          width: 50,
      }
  ];

  this.clusterOptions = {
      gridSize: 50,
      minimumClusterSize: 2,
      averageCenter: true,
      maxZoom: 30,
      styles: this.clusterStyles, 
      
  }

  }


 // google maps zoom level
 zoom: any =17 ;
  
 // initial center position for the map
 lat: number = 30.127371
 lng: number = -9.553743
 zoomPosition(e1,e2,e3){
   this.lat =e1
   this.lng =e2
   this.zoom =e3
   //console.log(this.lat ,this.lng ,this.zoom)
 }
 markers:marker[]=[];
 
 tmpPoints: marker[] = [
   {
     lat: 30.127371,
     lng: -9.553743,
     label: 'A',
     draggable: false
   },
   {
     lat: 30.127334,
     lng:  -9.553775,
     label: 'B',
     draggable: false
   },
   {
    lat: 30.127360,
    lng: -9.553795,
    label: 'C',
    draggable: false
  },
   {
     lat: 30.12719,
     lng: -9.553279,
     label: 'D',
     draggable: false
   },
   {
     lat: 30.12734,
     lng: -9.553289,
     label: 'D',
     draggable: false
   },
   {
     lat: 30.12747,
     lng: -9.553300,
     label: 'D',
     draggable: false
   },
   {
     lat: 30.12788,
     lng: -9.553400,
     label: 'D',
     draggable: false
   }
 ]
 
 calculateFunction(markers, numStyle: number){
 
  let index: number = 0
  let title: string = "ddfgdfg";
  let text: string = "<div style=\"position: relative; top: 2px; text-align: center; margin: 0px auto; width: 55px;\"> <div style=\"display: inline-block; width: 32px;\">{ELEMENTS}</div></div>";
  let qtdNodes: number = 0;
  let qtdEvents: number = 0;

  for(let i of markers){
      qtdNodes += i.zIndex;
      qtdEvents += i.zIndex;
      //console.log(i.zIndex ,qtdNodes)
  }

  index = (qtdEvents == 5) ? 1 : 2;

  text = text.replace( "{ELEMENTS}", qtdNodes.toString() );
  text = text.replace( "{PROBLEMS}", qtdEvents.toString() );

  return {
      text: text,
      index: index,
   
  }
 }
 
  drawPath(){

  this.markers.splice(0, this.markers.length);

  let i = 0;
  const obs =  interval(200).pipe(
    takeWhile((v) =>  i < this.tmpPoints.length))
    .subscribe(() => {
      const pos = this.tmpPoints[i];
      this.markers.push(pos);
     
      i++;
    });
}


}
